import { render, staticRenderFns } from "./ControlsAeration.vue?vue&type=template&id=0613b2d8&scoped=true"
import script from "./ControlsAeration.vue?vue&type=script&lang=js"
export * from "./ControlsAeration.vue?vue&type=script&lang=js"
import style0 from "./ControlsAeration.vue?vue&type=style&index=0&id=0613b2d8&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0613b2d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/publish/iot-cloud-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0613b2d8')) {
      api.createRecord('0613b2d8', component.options)
    } else {
      api.reload('0613b2d8', component.options)
    }
    module.hot.accept("./ControlsAeration.vue?vue&type=template&id=0613b2d8&scoped=true", function () {
      api.rerender('0613b2d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/control/components/ControlsAeration.vue"
export default component.exports